export default buttonsInfo => {
    const {buttons: {reloadButton}} = buttonsInfo;

    const errorsTypeInfo = {
        AUTOCAPTURE:[
            {
                codes: [402,405],
                title: "Tiempo caducado",
                message: "Lamentablemente, ha caducado el tiempo disponible para realizar el proceso de escaneo de cédula. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [403],
                title: "¡Oh oh! Cancelaste la operación",
                message: "Lamentablemente, cancelaste el proceso antes de terminarlo. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [404],
                title: "No tienes internet",
                message: "Por favor asegúrate de tener buena conexión a internet y luego intenta el proceso nuevamente.",
            },
            {
                codes: [407,409],
                title: "Cámara no disponible",
                message: "Lamentablemente, no contamos con acceso a la cámara. Por favor, asegúrate de haber entregado los permisos correspondientes al navegador para que pueda acceder a la cámara sin problemas.",
            },
            {
                codes: [408],
                title: "Navegador no soportado",
                message: "Lamentablemente, estás usando un navegador que el sistema no reconoce. Por favor, asegúrate de realizar el proceso desde SAFARI en caso de tener IOS, o desde CHROME en caso de tener Android.",
            },
            {
                codes: [410],
                title: "La cámara no cumple con la mínima resolución",
                message: "Lamentablemente, para realizar este proceso con éxito requerimos que la cámara del dispositivo móvil que utilizas tenga buena resolución. Por favor, intenta el proceso desde otro dispositivo.",
            },
            {
                codes: [401,406],
                title: "¡Oh oh! Ha ocurrido un error",
                message: "Lamentablemente, ha ocurrido un error en el proceso de captura de las cédulas. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [430],
                title: "No hemos logrado validar tu cédula",
                message: "Lamentablemente, no hemos logrado validar tu cédula con la imagen capturada. Por favor, inténtalo nuevamente.",
            },
        ],
        LIVENESS:[
            {
                codes: [402],
                title: "Tiempo caducado",
                message: "Lamentablemente, ha caducado el tiempo disponible para realizar el proceso de reconocimiento facial. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [403],
                title: "¡Oh oh! Cancelaste la operación",
                message: "Lamentablemente, cancelaste el proceso antes de terminarlo. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [404],
                title: "No tienes internet",
                message: "Por favor, asegúrate de tener buena conexión a internet y luego intenta el proceso nuevamente.",
            },
            {
                codes: [407,409],
                title: "Cámara no disponible",
                message: "Lamentablemente, no contamos con acceso a la cámara. Por favor, asegúrate de haber entregado los permisos correspondientes al navegador para que pueda acceder a la cámara sin problemas.",
            },
            {
                codes: [408],
                title: "Navegador no soportado",
                message: "Lamentablemente, estás usando un navegador que el sistema no reconoce. Por favor, asegúrate de realizar el proceso desde SAFARI en caso de tener IOS, o desde CHROME en caso de tener Android.",
            },
            {
                codes: [430],
                title: "No hemos podido identificar correctamente tu rostro",
                message: "Lamentablemente, no hemos podido identificar correctamente el rostro para realizar el reconocimiento facial. Por favor, inténtalo nuevamente.",
            },
            {
                codes: [405, 406, 411,412,413,450],
                title: "¡Oh oh! Ha ocurrido un error",
                message: "Lamentablemente, ha ocurrido un error en el proceso de reconocimiento facial. Por favor, inténtalo nuevamente.",
            },
        ],
    };

    const result = {errorNewStyle: {}, errorTypes: []};
    for (const service in errorsTypeInfo) {
        for (const serviceErrorTypeInfo of errorsTypeInfo[service]) {
            const {codes, title, message, reportToBack} = serviceErrorTypeInfo;
            for (const code of codes) {
                const errorTypeText = `${service}_${code}`;
                const customError = {
                    button: reloadButton,
                    principalMessage: title,
                    secondaryMessage: message,
                    errorTips: [],
                    code,
                    reportToBack: typeof reportToBack === "undefined" ? true : reportToBack,
                    errorKey: errorTypeText,
                };
                result.errorNewStyle[errorTypeText] = customError;
                result.errorTypes.push(errorTypeText);
            }
        }
    }
    return result;
};